<template>
    <div class="container">
        <div v-if="saldos.length" class="row">
            <div class="col-12 block-squad">
                <table id="orders_list">
                    <tr>
                        <th>Fecha</th>
                        <th>Descripción</th>
                        <th style="text-align: right;">Importe</th>
                        <th style="text-align: right;">Saldo</th>
                    </tr>
                    <tr v-for="(saldo, index) in saldos">
                        <td>{{saldo.fecha}}</td>
                        <td>{{saldo.descripcion}}</td>
                        <td style="text-align: right;">{{saldo.cantidad}} €</td>
                        <td style="text-align: right;">{{saldo.saldo}} €</td>
                    </tr>
                    <tr>
                        <th colspan="3"></th>
                        <th style="text-align: right;">{{totalSaldos}} €</th>
                    </tr>
                </table>
            </div>
        </div>
        <div v-else class="col-12 main_content">
            <div class="main_icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37">
                    <g fill="none">
                        <path fill="#000" d="M33.0098,11 L26.0098,11 L26.0098,9 C26.0098,3.70117 22.7198,0 18.0098,0 C13.2998,0 10.0098,3.70117 10.0098,9 L10.0098,11 L3.0098,11 L0.0098,37 L36.0098,37 L33.0098,11 Z"></path>
                        <path fill="#FFF" d="M12.0098,9 C12.0098,4.74756 14.36527,2 18.0098,2 C21.65433,2 24.0098,4.74756 24.0098,9 L24.0098,11 L12.0098,11 L12.0098,9 Z"></path>
                        <polygon fill="#E2EBF3" points="4.792 13 10.01 13 10.01 18 12.01 18 12.01 13 24.01 13 24.01 18 26.01 18 26.01 13 31.227 13 33.766 35 2.254 35"></polygon>
                    </g>
                </svg>
            </div>
            <span class="text_primary">
                No has realizado ninguna transacción.
            </span>
            <div class="bp-form-group">
                <a class="alter-btn" href="/">
                    <span>Volver a la tienda</span>
                    <svg class="dx-icon vnrwdl -OW70Q vnrwdl" height="1em" width="1em" focusable="false"
                         fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M3 11.3H18L15 8l1-1 5.1 5-5 5-1-1 3.1-3.3H3v-1.4z"></path>
                    </svg>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                saldos: [],
                totalSaldos: null,
            }
        },
        mounted() {
            this.loadSaldosClient();
        },
        methods: {
            loadSaldosClient: function () {
                axios.get(this.route('account.saldo.get.info')).then(response => {
                    let saldos = response.data.saldos;
                    let saldoAcumulado = 0;
                    saldos.forEach((saldo) => {
                        saldoAcumulado += parseFloat(saldo.cantidad);
                        saldo.saldo = saldoAcumulado;
                    })
                    this.saldos = saldos;
                    this.totalSaldos = response.data.saldoTotal;
                }).catch(e => {
                    console.log(e);
                });
            },
        }
    }
</script>
